module.exports = __webpack_public_path__ + "img/Weapon_189.bdff6741.png";